{
  "journalAudit.action.program.created": "Programme created",
  "v8e.code.PROGRAM_SETTINGS_CONFLICT": "The programme changed in the meantime: reload it before saving.",
  "v8e.code.PROJECT_ALREADY_ATTACHED": "This project is already attached to another programme: detach it first.",
  "v8e.code.PROJECT_ATTACHED_ELSEWHERE": "This project is attached to another programme: nothing to detach here.",
  "v8e.programmes.aucun": "No programme in the organisation yet: create the first one.",
  "v8e.programmes.aucun_choisi": "Choose a programme to see its details.",
  "v8e.programmes.aucun_resultat": "No programme matches the search.",
  "v8e.programmes.choisir": "View {{nom}}",
  "v8e.programmes.creer.aucun_modele": "No programme template offered: the programme will follow the default template.",
  "v8e.programmes.creer.description": "Description (optional)",
  "v8e.programmes.creer.geste": "Create the programme",
  "v8e.programmes.creer.modele": "Programme template",
  "v8e.programmes.creer.modele_aucun": "Platform default template",
  "v8e.programmes.creer.modele_defaut": "{{nom}} (default)",
  "v8e.programmes.creer.nom": "Programme name",
  "v8e.programmes.creer.propriete": "You become its owner: you administer the programme and its projects.",
  "v8e.programmes.creer.version_figee": "The published version of the template is frozen at creation.",
  "v8e.programmes.creer_un_programme": "Create a programme",
  "v8e.programmes.lien.ouvrir": "Open the programme",
  "v8e.programmes.lien.projets": "See the organisation's projects",
  "v8e.programmes.liste": "the organisation's programmes",
  "v8e.programmes.nom_invalide": "The programme name has 3 to 255 characters.",
  "v8e.programmes.panneau.aucun_projet": "No attached project.",
  "v8e.programmes.panneau.modele": "Template",
  "v8e.programmes.panneau.modele_par_defaut": "Default template",
  "v8e.programmes.panneau.projets_rattaches": "Attached projects ({{nombre}})",
  "v8e.programmes.panneau.proprietaires": "Owners",
  "v8e.programmes.panneau.reglages": "the programme settings",
  "v8e.programmes.projets_comptes": "{{nombre}} project(s)",
  "v8e.programmes.proprietaire": "owner: {{nom}}",
  "v8e.programmes.rattacher.actuel": "“{{projet}}” is attached to the programme “{{programme}}”.",
  "v8e.programmes.rattacher.choisir": "Choose a programme",
  "v8e.programmes.rattacher.consequence_modele": "The project keeps its template and version.",
  "v8e.programmes.rattacher.consequence_profils": "Profiles held on the programme also apply to the project.",
  "v8e.programmes.rattacher.detacher": "Detach from the programme",
  "v8e.programmes.rattacher.detacher_consequence": "The project leaves the programme “{{programme}}”; its inherited choices become its own.",
  "v8e.programmes.rattacher.detacher_d_abord": "To attach it to another programme, detach it first.",
  "v8e.programmes.rattacher.detacher_titre": "Detach “{{projet}}” from its programme?",
  "v8e.programmes.rattacher.geste": "Attach",
  "v8e.programmes.rattacher.option_actuelle": "{{nom}} (current)",
  "v8e.programmes.rattacher.programme": "Programme",
  "v8e.programmes.rattacher.projet": "the project",
  "v8e.programmes.rattacher.sans_programme": "“{{projet}}” is not attached to any programme.",
  "v8e.programmes.recherche": "Search for a programme",
  "v8e.programmes.renommer.conflit": "The programme changed in the meantime: its settings were reloaded, try again.",
  "v8e.programmes.renommer.geste": "Rename the programme",
  "v8e.programmes.renommer.nom": "New name",
  "v8e.programmes.renommer.reussi": "Programme renamed."
}
